import { render, staticRenderFns } from "./CustomFieldDialog.vue?vue&type=template&id=bf8ab8da&scoped=true&"
import script from "./CustomFieldDialog.vue?vue&type=script&lang=js&"
export * from "./CustomFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldDialog.vue?vue&type=style&index=0&id=bf8ab8da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8ab8da",
  null
  
)

export default component.exports